"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var errorMessageHoc_1 = require("../../../common/components/presentation/Error/errorMessageHoc");
var usePlatformConfig_1 = require("../../../common/react/usePlatformConfig");
var PaymentProviders_1 = require("../../../common/enum/PaymentProviders");
var ConfirmationReserveOnlineVisanet_1 = require("./ConfirmationReserveOnlineVisanet");
var ConfirmationReserveOnlineApexx_1 = require("./ConfirmationReserveOnlineApexx");
var ConfirmationReserveOnline = function () {
    var paymentProvider = usePlatformConfig_1.default().platformConfig.paymentProvider;
    if (PaymentProviders_1.PaymentProviders.VISA_NET === paymentProvider) {
        return <ConfirmationReserveOnlineVisanet_1.default />;
    }
    if (PaymentProviders_1.PaymentProviders.APEXX === paymentProvider) {
        return <ConfirmationReserveOnlineApexx_1.default />;
    }
    return <div data-test="confirmation_page:no_payment_provider">There is no payment provider</div>;
};
exports.default = errorMessageHoc_1.default(ConfirmationReserveOnline);
